import React from 'react';
import HeroSection from '../Components/herosection';
import HowWeHelp from '../Components/HowWeHelp';
import OurPOrtfolio from '../Components/Portfolio';
import CustomCarousel from '../Components/Customslider';
import ServedIndustries from '../Components/IndustriesServed';
import FAQ from '../Components/FAQ';
import BlogListPage from '../Components/BlogList';
import WorkWithUs from '../Components/Letworkwithus';


const Home = () => {
    return (
        <>
        <HeroSection/>
        <HowWeHelp/>
        <OurPOrtfolio/>
        <CustomCarousel/>
        <ServedIndustries/>
        <BlogListPage/>
        <WorkWithUs/>
        <FAQ/>
        </>
    );
};

export default Home;